// extracted by mini-css-extract-plugin
export default {"allBlock":"customers_allBlock__BqWp0","texts":"customers_texts__pd4Gr","reviews":"customers_reviews__neH5d","revie":"customers_revie__XOFzQ"};